/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { ParentLayout } from "../../../layout/parentLayout";
import { useNavigate } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  useAddWishListMutation,
  useGetWishListQuery,
} from "../../../service/wishListApi";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import useManageWishList from "../../../apiHooks/useManageWishlisht";
import { showToast } from "../../../constants/toast";
import { wishList } from "../../../types/General";
import { Box, Card, CardContent, Skeleton } from "@mui/material";
import NewSideBarParent from "../../../components/NewSideBarParent";
import SkeletonList from "../../../components/SkeltonTutor";
import TutorsCard from "../../../components/TutorsCard";
import Pagination from "../../../constants/Pagination";
import Loader from "../../../constants/Loader";
export default function ParentWishlist() {
  const navigate = useNavigate(); // hook for the navigation

  const { data, isError, isLoading, isSuccess } = useGetWishListQuery(); // api hook to fetch the wishlist listing
  const [addWishlist] = useAddWishListMutation();

  const handleWishList = async (item: wishList) => {
    //    console.log(item, "wish");
    try {
      let body = {
        tutorId: item?.tutorId,
      };

      const res = await addWishlist({ body }).unwrap();
      if (res?.statusCode === 200) {
        if (item?.isFav) {
          showToast("Tutor removed to wishlist");
        } else {
          showToast("Tutor added to wishlist");
        }
      }
    } catch (error: any) {
      //      console.log(error);
    }
  };
console.log(data?.data?.data,'data?.data?.data');


  return (
    <>
      <ParentLayout className="role-layout">
        <main className="content">
          {/* <section className="uhb_spc pWishlist_sc">
            <div className="conta_iner v2">
              <div className="role_head">
                <button
                  className="back_arrow"
                  onClick={() => navigate("/parent/search-result")}
                >
                  <img src={`/static/images/back.png`} alt="Back" />
                </button>
                <h1 className="hd_3">Wishlist</h1>
              </div>
              <div className="role_body">
                <div className="tutor_list gap_m">
                  {isLoading &&
                    Array.from(new Array(10))?.map((item, index) => (
                      <TutorCardSkeleton key={index} />
                    ))}
                  {isSuccess &&
                    data?.data?.data?.length ?
                    data?.data?.data.map((item, index) => (
                      <div className="tutor_item" key={item?.tutorId}>
                        <figure>
                          <img
                            src={
                              item?.tutors?.image && item?.tutors?.image !== ""
                                ? item?.tutors?.image
                                : "/static/images/userNew.png"
                            }
                            alt="tutor image"
                          />
                          {item?.avgRating && (
                            <span className="t_rating">
                              <StarIcon /> {item?.avgRating?.toFixed(1) || ""}
                            </span>
                          )}
                          <span
                            className="t_fav"
                            onClick={() => {
                              handleWishList(item);
                            }}
                          >
                            {item?.isFav ? (
                              <FavoriteIcon />
                            ) : (
                              <FavoriteBorderIcon />
                            )}
                          </span>
                        </figure>
                        <div
                          className="tutor_info"
                          onClick={() =>
                            navigate(`/parent/tutor-detail/${item?.tutorId}`, { state: "wishlist" })
                          }
                        >
                          <h2>{item?.tutors?.name || ""}</h2>
                          <p>
                            {item?.classCount
                              ? item.classCount > 99
                                ? "99+ classes"
                                : `${item.classCount} ${item.classCount > 1 ? "classes" : "class"}`
                              : ""}
                          </p>
                          <ins>
                            ${item?.teachingdetails[0]?.price || ""}/hour
                          </ins>
                        </div>
                      </div>
                    )) : <div className="no_data">
                      <figure>
                        <img src="/static/images/noData.png" alt="no data found" />
                      </figure>
                      <p>Wishlist is empty</p>
                    </div>}
                </div>
              </div>
            </div>
          </section> */}

          <section className="ut_spc home_wrp">
            <div className="conta_iner v2 parent_dash tutor_fx">
              <div className="gap_m">
                <NewSideBarParent />
                <div className="rt_s">
                  <div className="role_head">
                    <h1 className="hd_3">Wishlist</h1>
                  </div>


                  <div className="tutoer_list gap_m">
                    {isLoading &&
                      <Loader isLoad={isLoading} />
                    }

                    {isSuccess && data?.data?.data?.length ? (
                      data?.data?.data?.map((item: any, index: number) => {
                        return (
                          <TutorsCard isWishlist={true} item={item} />
                        )
                      })

                    ) : (
                      isLoading ? null :
                        <h3 style={{ textAlign: "center" }}>No Tutor found</h3>
                    )}

                  </div>

                </div>
              </div>
            </div>
          </section>
        </main>
      </ParentLayout>
    </>
  );
}


